import React from "react";
import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  TextField,
  EditButton,
  DateField,
  Resource,
  Show,
  ReferenceInput,
  SelectInput,
  Filter,
  ReferenceField,
  AutocompleteInput,
  Datagrid,
  useRecordContext,
  useGetOne
} from "react-admin";

const Filters = (props) => (
  <Filter {...props}>
    <ReferenceInput label="Origin" source="originId" reference="origins" filterToQuery={searchText => ({ name: searchText })} alwaysOn >
        <AutocompleteInput optionText="name"  />
    </ReferenceInput>
    <ReferenceInput label="Transport Mode" source="transportModeId" reference="transportModes">
        <SelectInput optionText="transportMode" />
    </ReferenceInput>
    <ReferenceInput label="Destination" source="destinationId" reference="origins">
        <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const RoundedNumberField = ({ source }) => {
  const record = useRecordContext();
  if (!record || !record[source]) return null;

  const roundedValue = Math.round(parseFloat(record[source]));

  return <span>{roundedValue}</span>;
};

const OriginField = ({ source }) => {
  const record = useRecordContext();
  const originId = record?.[source];

  const { data, loading } = useGetOne('origins', originId, { enabled: !!originId });

  if (!originId) return <span>-</span>;
  if (loading) return <span>-</span>;
  if (!data) return <span>-</span>;

  return (
    <a
      href={`#/origins/${originId}/show`}
      style={{ color: '#3f51b5', textDecoration: 'none' }}
      onClick={(e) => e.stopPropagation()}
    >
      {data.name}
    </a>
  );
};


const TransportOriginList = (props) => {
  return (
    <List {...props} filters={Filters(props)}>
      <div style={{marginTop: '15px'}}>
        <Datagrid rowClick="show">
          <TextField source="id" />
          <ReferenceField label="Transport Mode" source="transportModeId" reference="transportModes">
            <TextField source="transportMode" />
          </ReferenceField>
          <OriginField label="Origin" source="originId" />
          <OriginField label="Destination" source="destinationId" />
          <RoundedNumberField source="km" />
          <DateField source="createdAt" label="Creation date" />
          <DateField source="updatedAt" label="Update date" />
          <EditButton />
        </Datagrid>
      </div>
    </List>
  );
};

const ShowTransportOrigin = (props) => {
  return (
    <Show {...props}>
      <SimpleForm>
        <TextField source="id" />
        <ReferenceField label="Transport Mode" source="transportModeId" reference="transportModes">
          <TextField source="transportMode" />
        </ReferenceField>
        <ReferenceField label="Origin" source="originId" reference="origins">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField label="Destination" source="destinationId" reference="origins">
          <TextField source="name" />
        </ReferenceField>
        <RoundedNumberField source="km" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
      </SimpleForm>
    </Show>
  );
};

const CreateTransportOrigin = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <ReferenceInput label="Transport Mode" source="transportModeId" reference="transportModes">
          <SelectInput optionText="transportMode" />
        </ReferenceInput>
        <ReferenceInput label="Origin" source="originId" reference="origins">
          <SelectInput source="name" />
        </ReferenceInput>
        <ReferenceInput label="Destination" source="destinationId" reference="origins">
          <SelectInput source="name" />
        </ReferenceInput>
        <TextInput source="km" type="number" />
      </SimpleForm>
    </Create>
  );
};

const EditTransportOrigin = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <ReferenceInput label="Transport Mode" source="transportModeId" reference="transportModes">
          <SelectInput optionText="transportMode" />
        </ReferenceInput>
        <ReferenceInput label="Origin" source="originId" reference="origins">
          <SelectInput source="name" />
        </ReferenceInput>
        <ReferenceInput label="Destination" source="destinationId" reference="origins">
          <SelectInput source="name" />
        </ReferenceInput>
        <TextInput source="km" type="number" />
      </SimpleForm>
    </Edit>
  );
};


const transportOriginResource = () => <Resource
  name="transportDistances"
  options={{ label: 'Transport distances', menuGroup: 'Bcome'}}
  list={TransportOriginList}
  create={CreateTransportOrigin}
  edit={EditTransportOrigin}
  show={ShowTransportOrigin} />;

export default transportOriginResource;